<template>
  <CommonLayout header="customerHeader" footer="customerFooter">
    <CustomerMeetingLayout :type="this.consts.meetingType.customer" @changeIsOperationPossible="changeIsOperationPossible">
      <div class="base-color overflow-auto mh-550 vh-100 shadow">
        <div class="p-2">
          <b-overlay :show="overlayShow" rounded="sm">
            <h5 class="text-dark-blue font-weight-bold pt-3">■お客様情報入力内容確認</h5>
            <form method="post" action="#" class="form-horizontal">
              <div class="px-4">
                <div class="form-group row">
                  <div class="col-sm-12 row">
                    <div class="col-4 col-lg-3 p-0 header-text-size"><span class="font-weight-bold">ご両家様名</span></div>
                    <div class="col-1 col-sm-1 p-0">：</div>
                    <div class="col-7 col-lg-8 text-break result-input header-text-size" id="bothFamilyName"> {{getBothFamilyName1}}・{{getBothFamilyName2}} <span class="pl-3" style="font-size:small">ご両家様</span></div>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-sm-12 p-0">
                    <h5 class="font-weight-bold header-text-size">{{shinroShinpu1 !== 'shinro' ? '新婦様' : '新郎様'}}</h5>
                  </div>
                  <div class="col-sm-12 row">
                    <div class="col-4 col-lg-3 p-0 pl-3"><span>お名前</span></div>
                    <div class="col-1 col-sm-1 p-0">：</div>
                    <div class="col-7 col-lg-8 text-break result-input" id="groomName">{{getGroomLastName}} {{getGroomFirstName}}</div>
                  </div>
                  <div class="col-sm-12 row">
                    <div class="col-4 col-lg-3 p-0 pl-3"><span>お名前(カナ)</span></div>
                    <div class="col-1 col-sm-1 p-0">：</div>
                    <div class="col-7 col-lg-8 text-break result-input" id="groomNameKana">{{getGroomLastNameKana}} {{getGroomFirstNameKana}}</div>
                  </div>
                  <div class="col-sm-12 row mt-1">
                    <div class="col-4 col-lg-3 p-0 pl-3"><span>電話番号</span></div>
                    <div class="col-1 col-sm-1 p-0">：</div>
                    <div class="col-7 col-lg-8 text-break result-input" id="groomPhoneNumber">{{getGroomPhoneNumber}}</div>
                  </div>
                  <div class="col-sm-12 row">
                    <div class="col-4 col-lg-3 p-0"><span>メールアドレス</span></div>
                    <div class="col-1 col-sm-1 p-0">：</div>
                    <div class="col-7 col-lg-8 text-break result-input header-text-size" id="mailAddress">{{getMailAddress}}</div>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-sm-12 p-0">
                    <h5 class="font-weight-bold header-text-size">{{shinroShinpu2 !== 'shinpu' ? '新郎様' : '新婦様'}}</h5>
                  </div>
                  <div class="col-sm-12 row">
                    <div class="col-4 col-lg-3 p-0 pl-3"><span>お名前</span></div>
                    <div class="col-1 col-sm-1 p-0">：</div>
                    <div class="col-7 col-lg-8 text-break result-input" id="brideName">{{getBrideLastName}} {{getBrideFirstName}}</div>
                  </div>
                  <div class="col-sm-12 row">
                    <div class="col-4 col-lg-3 p-0 pl-3"><span>お名前(カナ)</span></div>
                    <div class="col-1 col-sm-1 p-0">：</div>
                    <div class="col-7 col-lg-8 text-break result-input" id="brideNameKana">{{getBrideLastNameKana}} {{getBrideFirstNameKana}}</div>
                  </div>
                  <div class="col-sm-12 row mt-1">
                    <div class="col-4 col-lg-3 p-0 pl-3"><span>電話番号</span></div>
                    <div class="col-1 col-sm-1 p-0">：</div>
                    <div class="col-7 col-lg-8 text-break result-input" id="bridePhoneNumber">{{getBridePhoneNumber}}</div>
                  </div>
                  <div class="col-sm-12 row">
                    <div class="col-4 col-lg-3 p-0"><span>メールアドレス</span></div>
                    <div class="col-1 col-sm-1 p-0">：</div>
                    <div class="col-7 col-lg-8 text-break header-text-size" id="brideMailAddress">{{getBrideMailAddress}}</div>
                  </div>
                </div>
              </div>
              <h5 class="header-bg-txt-color mt-5 mb-0 py-1">【個人情報のお取り扱いについて】</h5>
              <div class="col-sm-12 row px-0 mx-0">
                <div class="col-sm-12 overflow-auto border h-300">
                  <template v-for="(t, index) in this.consts.termsMsg.personalInformation">
                    <span :key="`first-${index}`">{{t}}</span>
                    <br :key="`second-${index}`"/>
                  </template>
                </div>
                <div class="col-sm-12 form-group mt-3 d-flex justify-content-center p-2">
                  <!--<div class="border-bottom form-check" :class="{'is-invalid' : validation.hasError('personalInformationCheck')}">-->
                  <!--  <input type="checkbox" class="form-check-input checkbox-scale-larger mt-2" id="personalInformationCheck" true-value="1" false-value="false" :class="{'is-invalid' : validation.hasError('personalInformationCheck')}" v-model="personalInformationCheck" @click="sendSignalingInputData">-->
                  <!--  <label class="form-check-label" for="personalInformationCheck">個人情報の取り扱いについて同意する</label>-->
                  <!--</div>-->
                  <label class="form-check-label labex-box-blue py-1 px-4" for="personalInformationCheck" :class="{'is-invalid' : validation.hasError('personalInformationCheck')}">
                    <input type="checkbox" class="checkbox-scale-larger mt-2" id="personalInformationCheck" true-value="1" false-value="" :class="{'is-invalid' : validation.hasError('personalInformationCheck')}" v-model="personalInformationCheck" @click="sendSignalingInputData" :disabled="!isOperationPossible">
                    同意する
                  </label>
                </div>
                <div class="invalid-feedback d-block text-center">{{ validation.firstError('personalInformationCheck') }}</div>
              </div>
              <hr class="border-gray">
              <h5 class="header-bg-txt-color mt-5 mb-0 py-1">【画像の撮影・お取り扱いについて】</h5>
              <div class="col-sm-12 row px-0 mx-0">
                <div class="col-sm-12 overflow-auto border h-300">
                  <template v-for="(t, index) in this.consts.termsMsg.imageCheck">
                    <span :key="`first-${index}`">{{t}}</span>
                    <br :key="`second-${index}`"/>
                  </template>
                </div>
                <div class="col-sm-12 form-group mt-3 d-flex justify-content-center p-2">
                  <!--<div class="border-bottom form-check">-->
                  <!--  <input type="checkbox" id="imageCheck" class="form-check-input checkbox-scale-larger mt-2" true-value="1" v-model="imageCheck" @click="sendSignalingInputData">-->
                  <!--  <label class="form-check-label" for="imageCheck">画像の取り扱いについて同意する</label>-->
                  <!--</div>-->
                  <label class="form-check-label labex-box-blue py-1 px-4 mr-4" for="imageCheck">
                    <input type="checkbox" id="imageCheck" true-value="1" false-value="" class="checkbox-scale-larger mt-2" v-model="imageCheck" @click="sendSignalingInputData" :disabled="!isOperationPossible">
                    同意する
                  </label>
                  <label class="form-check-label labex-box py-1 px-3" for="imageCheckDisagree">
                    <input type="checkbox" id="imageCheckDisagree" true-value="1" false-value="" class="checkbox-scale-larger mt-2" v-model="imageCheckDisagree" @click="sendSignalingInputData" :disabled="!isOperationPossible">
                    同意しない
                  </label>
                </div>
              </div>
              <div class="col-sm-12 text-right mb-2 mr-2">
                <b-button variant="outline-primary" class="w-25 sub-button-color back-button-disabled" @click="backPage" :disabled="!isOperationPossible">戻る</b-button>
                <b-button variant="primary" class="w-25 ml-3 main-button-color next-button-disabled" @click="nextPage" :disabled="!isOperationPossible">送信</b-button>
              </div>
            </form>
          </b-overlay>
        </div>
      </div>
    </CustomerMeetingLayout>
    <CommonModal ref="commonModal" />
  </CommonLayout>
</template>
<script>
import Vue from 'vue'
import CommonLayout from '@/layout/CommonLayout'
import CommonModal from '@/components/CommonModal'
import SimpleVueValidation from 'simple-vue-validator'
import cstore from '@/store/customer-store'
import mstore from '@/store/meeting-store'
import SignalingModel from '@/models/SignalingModel'
import CustomerRegistModel from '@/models/CustomerRegistModel'
import CommonLogModel from '@/models/CommonLogModel'
import CustomerMeetingLayout from '@/layout/CustomerMeetingLayout'
const Validator = SimpleVueValidation.Validator

Vue.use(SimpleVueValidation)

export default {
  name: 'CustomerMeetingConfirm',
  components: { CommonLayout, CustomerMeetingLayout, CommonModal, CustomerRegistModel },
  data () {
    return {
      overlayShow: false,
      personalInformationCheck: '',
      imageCheck: '',
      imageCheckDisagree: '',
      isSendFirstSignalingData: false,
      isOperationPossible: false,
      shinroShinpu1: 'shinro',
      shinroShinpu2: 'shinpu',
      customerDisplayFlag: cstore.getters.customerDisplayFlag === null ? false : cstore.getters.customerDisplayFlag
    }
  },
  computed: {
    getBothFamilyName1 () {
      return cstore.getters.bothFamilyName1
    },
    getBothFamilyName2 () {
      return cstore.getters.bothFamilyName2
    },
    getGroomLastName () {
      return cstore.getters.groomLastName
    },
    getGroomFirstName () {
      return cstore.getters.groomFirstName
    },
    getGroomLastNameKana () {
      return cstore.getters.groomLastNameKana
    },
    getGroomFirstNameKana () {
      return cstore.getters.groomFirstNameKana
    },
    getGroomPhoneNumber () {
      return cstore.getters.groomPhoneNumber
    },
    getBrideLastName () {
      return cstore.getters.brideLastName
    },
    getBrideFirstName () {
      return cstore.getters.brideFirstName
    },
    getBrideLastNameKana () {
      return cstore.getters.brideLastNameKana
    },
    getBrideFirstNameKana () {
      return cstore.getters.brideFirstNameKana
    },
    getBridePhoneNumber () {
      return cstore.getters.bridePhoneNumber
    },
    getMailAddress () {
      return cstore.getters.mailAddress
    },
    getBrideMailAddress () {
      return cstore.getters.brideMailAddress
    },
    getIsTargetAtendeeActive () {
      // フローリストとの疎通確立フラグ取得
      return mstore.getters.isTargetAtendeeActive
    },
    getSignalingData () {
      return cstore.getters.signalingReceiveData
    }
  },
  watch: {
    getIsTargetAtendeeActive: function (newData, oldData) {
      if (mstore.getters.isTargetAtendeeActive) {
        if (!cstore.getters.bothFamilyName1 ||
          !cstore.getters.bothFamilyName2 ||
          !cstore.getters.groomLastName ||
          !cstore.getters.groomFirstName ||
          !cstore.getters.groomPhoneNumber ||
          !cstore.getters.brideLastName ||
          !cstore.getters.brideFirstName ||
          !cstore.getters.bridePhoneNumber ||
          !cstore.getters.mailAddress ||
          !cstore.getters.brideMailAddress
        ) {
          cstore.commit('setErrorMsg', '値が不正です')
          this.backPage()
        }
      }

      if (!this.isSendFirstSignalingData && mstore.getters.isTargetAtendeeActive) {
        this.sendSignalingInputData()
        this.isSendFirstSignalingData = true
      }
    },
    getSignalingData (newData, oldData) {
      try {
        newData['user'] = 'customer'
        newData['timestampMs'] = Date.now()
        CommonLogModel.apiSetStore(this.$bvModal, newData, () => {
        })
        console.log('in getSignalingData()')
        console.log('newData:')
        console.log(newData)

        if (newData['event'] === 'click') {
          if (sessionStorage.customerType !== this.consts.customerType.guest) {
            if (newData['id'] === 'operationInvalid') {
              cstore.commit('setIsOperationPossible', false)
              this.isOperationPossible = false
            } else if (newData['id'] === 'operationPossible') {
              cstore.commit('setIsOperationPossible', true)
              this.isOperationPossible = true
            }
          }
          if (newData['id'] === 'next') {
            if (sessionStorage.customerType === this.consts.customerType.guest || sessionStorage.customerType === this.consts.customerType.main) {
              const customerTargetPath = newData['target_path'].replace('florist', 'customer')
              this.signalingNextPage(customerTargetPath)
            } else {
              this.signalingNextPage(newData['target_path'])
            }
          }
          if (newData['id'] === 'back') {
            if (sessionStorage.customerType === this.consts.customerType.guest || sessionStorage.customerType === this.consts.customerType.main) {
              const customerTargetPath = newData['target_path'].replace('florist', 'customer')
              this.signalingBackPage(customerTargetPath)
            } else {
              this.signalingBackPage(newData['target_path'])
            }
          }
          if (newData['id'] === 'priceHide') {
            cstore.commit('setCustomerDisplayFlag', false)
            this.customerDisplayFlag = cstore.getters.customerDisplayFlag
          } else if (newData['id'] === 'priceDisplay') {
            cstore.commit('setCustomerDisplayFlag', true)
            this.customerDisplayFlag = cstore.getters.customerDisplayFlag
          }
        }

        if (!cstore.getters.isOperationPossible) {
          if (newData['event'] === 'input') {
            console.log("newData['data']:")
            console.log(newData['data'])
            for (var i = 0; i < newData['data'].length; i++) {
              if (newData['data'][i] && newData['data'][i].id) {
                console.log(newData['data'][i])
                console.log(newData['data'][i].id)
                let elm = document.getElementById(newData['data'][i].id)
                if (!elm) {
                  continue
                }

                // if (elm.classList.contains('form-check-input')) {
                if (elm.getAttribute('type') === 'checkbox') {
                  elm.checked = newData['data'][i].value
                  elm.value = newData['data'][i].value ? 1 : ''
                  // elm.checked = newData['data'][i].value === '1'
                  // elm.value = newData['data'][i].value
                  elm.dispatchEvent(new Event('change'))
                } else {
                  elm.innerHTML = newData['data'][i].value
                }
              }
            }
          }
        }
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
        return false
      }
    }
  },
  validators: {
    personalInformationCheck: function (value) {
      return Validator.value(value).required(this.consts.validationMsg.meetingComfirm.personalInformationCheck.required)
    }
  },
  methods: {
    sendSignalingInputData: function (e) {
      try {
        if (this.isOperationPossible) {
          // クリックイベントで呼び出された場合(=引数 e に値が渡されている場合)にidを取得
          const clickedElmID = e ? e.target.id : ''
          if (clickedElmID === 'imageCheck' || clickedElmID === 'imageCheckDisagree') {
            // クリックされたのが、画像利用目的の「同意する」「同意しない」チェックの場合、チェックボックストグル処理を実施
            this.toggleAgreeButton(e.target)
          }

          let sendData = []
          const resultInputs = document.getElementsByClassName('result-input')
          for (let i = 0; i < resultInputs.length; i++) {
            sendData.push({'id': resultInputs[i].id, 'value': resultInputs[i].innerHTML})
          }
          const checkInputs = document.querySelectorAll('input[type="checkbox"]')
          for (let i = 0; i < checkInputs.length; i++) {
            sendData.push({'id': checkInputs[i].id, 'value': checkInputs[i].checked})
          }
          // // 同意チェックボックスの値をシグナリングで送信するデータにセットする
          // sendData.push({'id': 'personalInformationCheck', 'value': this.personalInformationCheck})
          // sendData.push({'id': 'imageCheck', 'value': this.imageCheck})
          // sendData.push({'id': 'imageCheckDisagree', 'value': this.imageCheckDisagree})
          SignalingModel.sendInputEvent(this, sendData)
        }
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    nextPage: async function () {
      try {
        let isError = await this.$validate()
          .then((success) => {
            return !success
          })

        if (isError) {
          return false
        }

        let imageFlag = ''
        if (this.imageCheck) {
          imageFlag = '01'
        } else if (this.imageCheckDisagree) {
          imageFlag = '02'
        } else {
          imageFlag = '00'
        }

        const params = {
          'bothFamilyName1': cstore.getters.bothFamilyName1,
          'bothFamilyName2': cstore.getters.bothFamilyName2,
          'groomLastName': cstore.getters.groomLastName,
          'groomFirstName': cstore.getters.groomFirstName,
          'groomLastNameKana': cstore.getters.groomLastNameKana,
          'groomFirstNameKana': cstore.getters.groomFirstNameKana,
          'groomPhoneNumber': cstore.getters.groomPhoneNumber,
          'brideLastName': cstore.getters.brideLastName,
          'brideFirstName': cstore.getters.brideFirstName,
          'brideLastNameKana': cstore.getters.brideLastNameKana,
          'brideFirstNameKana': cstore.getters.brideFirstNameKana,
          'bridePhoneNumber': cstore.getters.bridePhoneNumber,
          'mailAddress': cstore.getters.mailAddress,
          'brideMailAddress': cstore.getters.brideMailAddress,
          'shinroShinpu1': cstore.getters.shinroShinpu1,
          'shinroShinpu2': cstore.getters.shinroShinpu2,
          'personalInformationFlag': this.personalInformationCheck ? '01' : '00',
          'imageFlag': imageFlag
        }

        this.overlayShow = true
        const customerRegistModel = await CustomerRegistModel.apiSetStore(this.$bvModal, params, () => {
          this.overlayShow = false
        })
        if (!customerRegistModel) {
          this.$refs.commonModal.msgBoxOk('お客様情報の更新に失敗しました')
          return false
        }
        if (customerRegistModel.status !== 'success' || customerRegistModel.message) {
          // エラーが発生していた場合
          this.$refs.commonModal.msgBoxOk(customerRegistModel.message)
          return false
        }
        const targetPath = '/customer/meeting/send_mail'
        SignalingModel.sendClickEvent('next', this, {'target_path': targetPath.replace('customer', 'florist')})
        this.$router.push(targetPath)
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
        return false
      }
    },
    signalingNextPage: async function (targetPath) {
      try {
        if (targetPath === '/customer/meeting/send_mail') {
          let isError = await this.$validate()
            .then((success) => {
              return !success
            })

          if (isError) {
            return false
          }
        }
        this.$router.push(targetPath)
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
        return false
      }
    },
    backPage () {
      try {
        const targetPath = '/customer/meeting/input'
        SignalingModel.sendClickEvent('back', this, {'target_path': targetPath.replace('customer', 'florist')})
        this.$router.push(targetPath)
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    signalingBackPage (targetPath) {
      try {
        this.$router.push(targetPath)
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    toggleAgreeButton (targetElm) {
      try {
        // 「同意する」「同意しない」チェックボックスのON/OFFを切り替える
        if (targetElm.id === 'imageCheck') {
          this.imageCheckDisagree = targetElm.checked ? '' : '1'
          document.getElementById('imageCheckDisagree').checked = !targetElm.checked
        } else {
          this.imageCheck = targetElm.checked ? '' : '1'
          document.getElementById('imageCheck').checked = !targetElm.checked
        }
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    changeIsOperationPossible (value) {
      this.isOperationPossible = value
    }
  },
  mounted () {
    try {
      this.isOperationPossible = cstore.getters.isOperationPossible
      cstore.commit('setIsOperationPossible', this.isOperationPossible)
      if (!this.isSendFirstSignalingData && mstore.getters.isTargetAtendeeActive) {
        this.sendSignalingInputData()
        this.isSendFirstSignalingData = true
      }

      // 新郎、新婦の状態を取得
      this.shinroShinpu1 = cstore.getters.shinroShinpu1
      this.shinroShinpu2 = cstore.getters.shinroShinpu2
    } catch (err) {
      CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
      })
    }
  }
}
</script>
<style scoped type="text/css">
  .back-button-disabled:disabled {
  background-color: #fff;
  color: rgb(0, 123, 255);
  border-color: rgb(0, 123, 255);
  opacity: 1;
  }
  .next-button-disabled:disabled {
  background-color: rgb(0, 123, 255);
  color: #fff;
  opacity: 1;
  }
</style>



// WEBPACK FOOTER //
// src/pages/CustomerMeetingConfirm.vue